/**
 * Converts a camelCase or PascalCase string into a human-readable, title-cased phrase.
 *
 * Examples:
 * ```ts
 * formatCamelOrPascalToTitleCaseWords("someValue");      // "Some Value"
 * formatCamelOrPascalToTitleCaseWords("northAmerica");   // "North America"
 * formatCamelOrPascalToTitleCaseWords("UserIDNumber");   // "User ID Number"
 * formatCamelOrPascalToTitleCaseWords("");               // ""
 * ```
 *
 * @param value - The camelCase or PascalCase string to format.
 * @returns The formatted string with spaces and title case applied.
 */
export function formatCamelOrPascalToTitleCaseWords(value: string): string {
  if (!value) return '';

  // Split before uppercase letters that are followed by lowercase OR before end of consecutive capitals
  // eslint-disable-next-line sonarjs/super-linear-regex, sonarjs/regex-complexity -- identifier-length input; rewriting the word-split regex risks changing output
  const words = value.match(/([A-Z]+(?=[A-Z][a-z])|[A-Z]?[a-z]+|[A-Z]+|\d+)/g);

  if (!words) return value;

  return words.map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
